import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:주문서 상세보기
 * 세부설명:
*/

export class LiveChatOrderPaper extends Component {
    static displayName = LiveChatOrderPaper.name;

    constructor(props) {
        super(props);
        this.state = {
            OrdDtl: [],
            RetailInfo:[]
        };
        this.Union_Uid = "";
        this.Ordgrp_No = 0;
    }
    //초기화
    async componentDidMount() {
        
    }
    async CallOrdMgtMstDtlListData() {
        try {

            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/Order/OrderMgr/GetOrdMgtMstDtl',
                {
                    Union_Uid: this.Union_Uid,
                    Ordgrp_No: this.Ordgrp_No
                }, true);

            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const OrdDtl = DataList.OrdDtl;
                const RetailInfo = DataList.Summary;
                this.setState({ OrdDtl: OrdDtl, RetailInfo: RetailInfo});
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallOrdMgtMstDtlListData", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    CallOrdMgtMstDtlRef = (union_uid, ordgrp_no) => {
        this.Union_Uid = union_uid;
        this.Ordgrp_No = ordgrp_no;
        this.CallOrdMgtMstDtlListData();
    }
    GoodsOrderrender() {
        const OrdDtl = this.state.OrdDtl;
        return (
            <>
                {
                    <div className="table_box" >
                        <React.Fragment>
                            <table className="table">
                                <colgroup>
                                    <col width="44%" />
                                    <col width="12%" />
                                    <col width="44%" />
                                </colgroup>
                                <tbody>
                                    {OrdDtl.map(list =>
                                        <tr key={list.ordno}>
                                            <td>{list.crd_cd_nm}  / {list.size_nm}  ({Big3Common.Util.Money(list.goods_price)})</td>
                                            <td>{list.quan}</td>
                                            <td>{Big3Common.Util.Money(list.goods_price_sum)}원</td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td>합계</td>
                                        <td>{OrdDtl.reduce((acc, item) => acc + item.quan, 0)}</td>
                                        <td>{Big3Common.Util.Money(OrdDtl.reduce((acc, item) => acc + item.goods_price_sum, 0))}원</td>
                                    </tr>
                                </tfoot>
                            </table>
                        </React.Fragment>
                    </div>
                }
            </>
        )
    }
    render() {
        let RetailInfo = "";
        if (this.state.RetailInfo.length > 0) {
            RetailInfo=this.state.RetailInfo[0];
        }
        const OrdDtl = this.state.OrdDtl;
        
        return (
            <div className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false"
                data-bs-backdrop={this.props.backdrop === undefined ? "static" : this.props.backdrop}>
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" >
                    <div className="modal-content">
                        <div className="container_box d_padding  p_b_margin" style={{ overflowY: "auto", margin:"0px" }}>
                            <div className="order_dtl_box">
                                <div className="order_shop_info_box">
                                    <div className="shop_name">[{RetailInfo.retail_area_nm || ""}] {RetailInfo.retail_org_name || "" }</div>
                                    <div className="date">2023-12-12</div>
                                    <div className="shop_info_first_line">
                                        <div className="shop_info_1">전화번호 : {RetailInfo.retail_user_phone || ""}</div>
                                        {RetailInfo.ord_use === "SS" ? <div className="shop_info_2 shop_buyer">사입자 : {RetailInfo.bumastername}</div> : <div className="shop_info_2 shop_buyer">{RetailInfo.ord_use_nm}</div>}
                                    </div>
                                    <div className="shop_info_second_line">
                                        <div className="shop_info_1">{RetailInfo.pay_idx_nm || ""}</div>
                                        {RetailInfo.pay_idx === "OL" ? <div className="shop_info_2">입금자 : {RetailInfo.account_holder}</div> : ""}
                                    </div>
                                    <div className="order_status">{RetailInfo.ord_status_nm || ""}</div>
                                </div>
                                {this.GoodsOrderrender()}
                            </div>
                            <div className="table_box sum_table">
                                <React.Fragment>
                                    <table className="table">
                                        <colgroup>
                                            <col width="44%" />
                                            <col width="12%" />
                                            <col width="44%" />
                                        </colgroup>
                                        <tbody>
                                            <tr>
                                                <td>총 합계</td>
                                                <td>{OrdDtl.reduce((acc, item) => acc + item.quan, 0)}</td>
                                                <td>{Big3Common.Util.Money(OrdDtl.reduce((acc, item) => acc + item.goods_price_sum, 0))}원</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </React.Fragment>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn" data-bs-dismiss="modal">확인</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
